declare namespace $ {

	type $mol_view__sub_shm_hitalama_notifications_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_notifications['notification_title_visible'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_notifications_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_notifications_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_notifications['copy'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_notifications_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_notifications['details_visible'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_notifications_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_notifications_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_notifications['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_notifications_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__attr_shm_hitalama_notifications_14 = $mol_type_enforce<
		({ 
			'notification_type': ReturnType< $shm_hitalama_notifications['type'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_notifications_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_notifications extends $mol_view {
		type( id: any): string
		notification_title( id: any): string
		Title( id: any): $mol_view
		notification_title_visible( id: any): readonly(any)[]
		Title_holder( id: any): $mol_view
		message( id: any): string
		Message( id: any): $mol_view
		details( id: any): string
		Details( id: any): $mol_view
		copy( id: any, next?: any ): any
		Copy_icon( id: any): $mol_icon_content_copy
		Copy( id: any): $mol_button_minor
		Details_row( id: any): $mol_view
		details_visible( id: any): readonly(any)[]
		Details_holder( id: any): $mol_view
		Content( id: any): $mol_view
		close( id: any, next?: any ): any
		Close_icon( id: any): $mol_icon_close
		Close( id: any): $mol_button_minor
		Card( id: any): $mol_view
		Row( id: any): $mol_view
		rows( ): readonly(any)[]
		sub( ): ReturnType< $shm_hitalama_notifications['rows'] >
	}
	
}

//# sourceMappingURL=notifications.view.tree.d.ts.map